import { render, staticRenderFns } from "./booked-seats.vue?vue&type=template&id=5b8b51a1&scoped=true"
import script from "./booked-seats.vue?vue&type=script&lang=js"
export * from "./booked-seats.vue?vue&type=script&lang=js"
import style0 from "./booked-seats.vue?vue&type=style&index=0&id=5b8b51a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b51a1",
  null
  
)

export default component.exports